import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ThresholdSettingsComponent from '../components/ThresholdSettingsComponent';
import IAppState from '../../../IAppState';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import {
    IThresholdSettingsData,
    IThresholdSettingsFunctions,
} from '../props/IThresholdSettingsProps';


interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IThresholdSettingsData => {
    return {

        ...mainState,
        evolutionFoldXThreshold : mainState.advancedOptions.evolutionFoldXThreshold,
        energyFoldXThreshold: mainState.advancedOptions.energyFoldXThreshold,
        energyRosettaThreshold: mainState.advancedOptions.energyRosettaThreshold,
        multipointRosettaThreshold: mainState.advancedOptions.multipointRosettaThreshold,
        limitForceFields: mainState.advancedOptions.limitForceFields,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IThresholdSettingsFunctions => ({
    changeEvolutionFoldXThreshold: (evolutionFoldXThreshold: number ) => dispatch(ActMain.changeEvolutionFoldXThreshold(evolutionFoldXThreshold)),
    changeEnergyFoldXThreshold : (energyFoldXThreshold: number ) => dispatch(ActMain.changeEnergyFoldXThreshold (energyFoldXThreshold)),
    changeEnergyRosettaThreshold : (energyRosettaThreshold: number ) => dispatch(ActMain.changeEnergyRosettaThreshold(energyRosettaThreshold)),
    changeMultipointRosettaThreshold : (multipointRosettaThreshold: number ) => dispatch(ActMain.changeMultipointRosettaThreshold(multipointRosettaThreshold)),
    changeLimitForceFields : (limitForceFields: boolean ) => dispatch(ActMain.changeLimitForceFields(limitForceFields)),
});

const ThresholdSettingsContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ThresholdSettingsComponent)
);
export default ThresholdSettingsContainer;
